// React & Vendor Libs
import Styled from "styled-components";

// NekoUI
import { NekoModal } from '@neko-ui';

export const LoadEntryModal = Styled(NekoModal)`
    width: 80vw;
    max-width: 80vw !important;
    max-height: 85vh;
`;